import Vue from 'vue'

import { Colors } from '@sigma-frontend-libs/commons'
import { Currency } from '@sigmasms/shared-types'

import { buttonModes, components, services } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import paymentsForm from '@/components/services/payments/form'
import layoutTitle from '@/components/title/layout'

function renderHeader(h) {
  return h(
    layoutTitle,
    {
      props: {
        value: this.getTranslate('pay.title')
      }
    }
  )
}

function renderWarning(h) {
  if (this.warningTranslatePath) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(this.warningTranslatePath),
          color: Colors.error
        }
      }
    )
  }
}
function renderForm(h) {
  return h(
    paymentsForm,
    {
      props: {
        OwnerId: this.owner,
        value: this.payload,
        methods: this.availableMethods,
        currency: Currency.RUB
      },
      on: {
        input: event => {
          this.payload = event
        },
        validation: event => {
          this.formValidation = event
        }
      }
    }
  )
}
function renderActions(h) {
  return h(
    'div',
    {
      class: 'pay-footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.pay'),
            loading: this.loading,
            disabled: this.loading || !this.formValidation,
            color: Colors.primary
          },
          on: {
            click: () => {
              this.requestPayment()
            }
          }
        }
      )
    ]
  )
}
function renderContent(h) {
  return h(
    'div',
    {
      class: 'pay-content'
    },
    [
      renderForm.call(this, h),
      renderActions.call(this, h)
    ]
  )
}
function renderBody(h) {
  return h(
    components.card,
    {
      props: {
        outline: true,
        rounded: true,
        maxWidth: 400
      }
    },
    [ renderWarning.call(this, h) || renderContent.call(this, h) ]
  )
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: 'pay-footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate(`${services.login}.buttons.signup`),
            mode: buttonModes.flat,
            name: 'registration'
          },
          on: {
            click: () => {
              Vue.router.push({ name: 'registration' })
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate(`${services.login}.buttons.signin`),
            mode: buttonModes.flat,
            name: 'login'
          },
          on: {
            click: () => {
              Vue.router.push({ name: 'login' })
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'pay'
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
